import { render, staticRenderFns } from "./BtnInserirCronogramaRecebimento.vue?vue&type=template&id=665d9d63&"
import script from "./BtnInserirCronogramaRecebimento.vue?vue&type=script&lang=js&"
export * from "./BtnInserirCronogramaRecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports